// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".b78bbe32cd3bedafef5204a2d4954a87e9092327.chunk.js";
};